Jelly.Actions.Validate_Member = function(Parameters) { 

	// Validate input
	var Email_Validator = new RegExp('^\[^@\\s\]+@\[^@\\s\]+\\.\[^@\\s\]+$', 'i');
	if (!Parameters.Name) { 
		return'Please enter a name';
	}
	if (!Email_Validator.test(Parameters.Email)) {
		return 'Please enter a valid email address';
	}
	if (Parameters.Phone && !(/^\d{7,}$/).test(Parameters.Phone.replace(/[\s()+\-\.]|ext/gi, ''))) {
		return 'Please enter a valid phone number';
	}

	if (Parameters.Skip_Table_Duplicate_Check) {
		return;
	}

	// Make sure that member doesn't already exist in table
	var Email_Is_Unique = true;
	var Normalized_Email = String(Parameters.Email).trim().toLowerCase();
	var $Add_Member_Table_Wrapper = $(
		"#" + Parameters.Namespace.Action + "_" + Parameters.Namespace.Membership + "_Add_Member_Table_Wrapper"
	);
	$Add_Member_Table_Wrapper.find('tbody tr').each(function(Row_Index, Row) {
		if (Normalized_Email === $(Row).find('td:eq(1)').text().trim().toLowerCase()) {
			Email_Is_Unique = false;
			return false;
		}
	});
	if (!Email_Is_Unique)
		return "You've already entered this email address";
};
